import { render, staticRenderFns } from "./DateOfBirthSelector2.vue?vue&type=template&id=a6e1cb38&scoped=true"
import script from "./DateOfBirthSelector2.vue?vue&type=script&lang=js"
export * from "./DateOfBirthSelector2.vue?vue&type=script&lang=js"
import style0 from "./DateOfBirthSelector2.vue?vue&type=style&index=0&id=a6e1cb38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e1cb38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6e1cb38')) {
      api.createRecord('a6e1cb38', component.options)
    } else {
      api.reload('a6e1cb38', component.options)
    }
    module.hot.accept("./DateOfBirthSelector2.vue?vue&type=template&id=a6e1cb38&scoped=true", function () {
      api.rerender('a6e1cb38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/DateOfBirthSelector2.vue"
export default component.exports